import { type ApiHelper, ApiHelperWithData } from '@ocodelib/api-common';

export class ServerProxyApi {
  private withData: ApiHelperWithData;

  constructor(private helper: ApiHelper) {
    this.withData = new ApiHelperWithData(helper);
  }

  proxyGet = (url: string, options?: RequestInit) => {
    const proxyUrl = `${this.helper.apiBaseURL}/api/proxy-get?url=${encodeURIComponent(url)}`;

    const defaultHeader = this.helper.createApiHeader();
    const { headers: optionHeaders, ...restOptions } = options || {};
    const headers = {
      ...defaultHeader,
      ...optionHeaders,
    };

    return fetch(proxyUrl, { method: 'GET', headers, ...restOptions });
  };
}
